/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext, useEffect, useState } from 'react';
import {
  FacephiSdkProvider,
  TypeFamily,
  FacephiSdkProviderCustomEvent,
  ExportData,
  TrackingSteps,
} from '@facephi/sdk-web-react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { useVariables } from '../hooks';
import { useAuth } from '../providers';
import {
  operationIdState,
  sessionIdState,
  newOperationIdState,
} from '../states/atoms';

type IProps = {
  children?: React.ReactNode;
  disabled?: boolean;
  steps: TrackingSteps[];
};

type ContextProps = {
  operationId?: string;
  sessionId?: string;
};

const Ctx = createContext<ContextProps>({
  operationId: undefined,
  sessionId: undefined,
});

export const ExtendedSdkProvider = ({
  children,
  disabled = false,
  steps,
}: IProps) => {
  const { email, tenantDefault } = useAuth();
  const { sdkApiKey } = useVariables();
  const [operationId, setOperationId] = useRecoilState(operationIdState);
  const [sessionId, setSessionId] = useRecoilState(sessionIdState);
  const newOperationId: string = useRecoilValue(newOperationIdState);
  const [flowOperationId, setFlowOperationId] = useState('');
  const [key, setKey] = useState(0);

  const onEmitData = (event: FacephiSdkProviderCustomEvent<ExportData>) => {
    setSessionId(event.detail.sessionId);
    setOperationId(event.detail.operationId);
  };

  useEffect(() => {
    setFlowOperationId(newOperationId);
  }, [newOperationId]);

  useEffect(() => {
    setKey((key) => key + 1);
  }, [tenantDefault]);

  return (
    <Ctx.Provider
      value={{
        operationId,
        sessionId,
      }}
    >
      {flowOperationId ? (
        <FacephiSdkProvider
          customerId={email}
          apikey={sdkApiKey}
          operationId={flowOperationId}
          onEmitData={onEmitData}
          type={TypeFamily.authentication}
          bundlePath="/widgets"
          disabled={disabled}
          steps={steps.join(',')}
          tenantId={tenantDefault}
        >
          {children}
        </FacephiSdkProvider>
      ) : (
        <>{children}</>
      )}
    </Ctx.Provider>
  );
};

export const useSdk = () => useContext(Ctx);
